import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const Modal = styled.div`
  padding: 10px 14px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
`;

export const ModalHeader = styled.h3``;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 6px;
`;

export const ModalText = styled.p``;

export const Select = styled.select`
  padding: 4px;
`;

export const Option = styled.option``;

export const ButtonWrapper = styled.div`
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ddd;
`;

export const CancelButton = styled.button`
  color: ${(p) =>
    p.theme.colors.primary ? p.theme.colors.primary : "#404e67"};
  cursor: pointer;
  background-color: #fff;
  border: none;

  &:focus {
    outline: 0;
  }
  &:focus-visible {
    outline: 2px solid blue;
    border-radius: 4px;
  }
`;

export const ConfirmButton = styled(CancelButton)`
  padding: 5px 8px;
  border-radius: 4px;
  background-color: ${(p) =>
    p.theme.colors.success ? p.theme.colors.success : "#404e67"};
  color: ${(p) =>
    p.theme.colors.on.success ? p.theme.colors.on.success : "#f5f5f5"};
  border: ${(p) =>
    p.theme.colors.border.success
      ? `1px solid ${p.theme.colors.border.success}`
      : "none"};
`;
